import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const questionById = createAsyncThunk(
  TYPES.QUESTION_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.questionById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionCreate = createAsyncThunk(
  TYPES.QUESTION_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.questionCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionDelete = createAsyncThunk(
  TYPES.QUESTION_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.questionDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionAll = createAsyncThunk(
  TYPES.QUESTION_ALL,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.questionAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionTypes = createAsyncThunk(
  TYPES.QUESTION_TYPES,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION_TYPES}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.questionTypes(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionTypesCounts = createAsyncThunk(
  TYPES.QUESTION_TYPES_COUNTS,
  async (params: PayloadCreatorParams<`${typeof API.QUESTION_TYPES_COUNTS}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.questionTypesCounts(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const questionAllClear = createAction(`${TYPES.QUESTION_ALL}/clear`)

export const questionTypesClear = createAction(`${TYPES.QUESTION_TYPES}/clear`)

export const questionTypesCountsClear = createAction(`${TYPES.QUESTION_TYPES_COUNTS}/clear`)
